import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onethreetempo() {



const cardData = {
keyword: "13 Seater Tempo Traveller on Rent",
headingDescription: "Ruturaj Enterprises provides comfortable and reliable 13 Seater Tempo Traveller on Rent services in Pune for families, friends, corporate groups, wedding guests, school groups, airport transfers, sightseeing programs, picnics, and outstation journeys. A 13 seater Tempo Traveller is an excellent choice for medium-sized groups who want to travel together with convenient seating, sufficient luggage space, and a well-organized transportation experience for both short and long-distance trips.",
topPlaces: [
{
title: "Lonavala",
description: "Lonavala is a popular weekend destination from Pune, attracting families, friends, corporate groups, and college travelers throughout the year. A 13 seater Tempo Traveller makes the journey convenient by allowing the complete group to travel together while carrying luggage and other essentials comfortably."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is well known for its pleasant climate, viewpoints, strawberry farms, and scenic surroundings, making it ideal for family vacations and group tours. A 13 seater Tempo Traveller provides a practical travel solution for groups planning a full-day or multi-day journey from Pune."
},
{
title: "Shirdi",
description: "Shirdi is an important pilgrimage destination visited by families, devotees, and organized groups from Pune. Hiring a 13 seater Tempo Traveller allows passengers to travel together for the temple visit while keeping the journey coordinated and convenient."
},
{
title: "Nashik",
description: "Nashik is a popular destination for religious tours, family holidays, vineyard visits, and weekend travel from Pune. Groups can use a 13 seater Tempo Traveller for comfortable transportation between Pune, Nashik, Trimbakeshwar, and other nearby attractions."
},
{
title: "Goa",
description: "Goa is a preferred destination for group vacations, family holidays, college tours, and corporate trips from Pune. A 13 seater Tempo Traveller is suitable for long-distance group travel, providing a shared vehicle for the journey and convenient movement during the planned tour."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal getaway for families and groups looking for beaches, resorts, and a relaxing weekend vacation. A 13 seater Tempo Traveller offers an organized transportation option from Pune and provides useful space for passengers and their travel luggage."
},
{
title: "Kolhapur",
description: "Kolhapur attracts visitors for its temples, historical attractions, traditional culture, and regional cuisine. A 13 seater Tempo Traveller works well for family groups, pilgrimage trips, and tourist circuits where travelers prefer to remain together throughout the journey."
},
{
title: "Aurangabad",
description: "Aurangabad, now Chhatrapati Sambhajinagar, is known for heritage attractions and access to destinations such as Ellora and Ajanta. A 13 seater Tempo Traveller is a convenient choice for groups planning an educational, historical, family, or sightseeing tour from Pune."
},
{
title: "Panchgani",
description: "Panchgani is a scenic hill station known for its viewpoints, pleasant surroundings, and relaxed holiday atmosphere. Families and small groups can choose a 13 seater Tempo Traveller for comfortable travel from Pune while keeping the complete group together."
},
{
title: "Matheran",
description: "Matheran is a popular hill destination known for its natural surroundings, viewpoints, and vehicle-free town area. A 13 seater Tempo Traveller can provide convenient transportation for groups traveling from Pune to the nearby destination and help organize the journey around the planned sightseeing schedule."
}
],
services: [
{
name: "13 Seater Tempo Traveller Pune",
description: "Ruturaj Enterprises offers 13 Seater Tempo Traveller Pune services for families, friends, corporate teams, tourists, wedding groups, and other medium-sized travel groups. The vehicle provides a convenient shared travel option for local sightseeing, airport transfers, private functions, weekend trips, and longer journeys from Pune."
},
{
name: "13 Seater Tempo Traveller Hire Pune",
description: "13 Seater Tempo Traveller Hire Pune is suitable for travelers who want one comfortable vehicle for their complete group instead of arranging multiple cars. Ruturaj Enterprises can support requirements for family tours, corporate programs, weddings, school activities, sightseeing, and private travel."
},
{
name: "13 Seater Tempo Traveller Booking Pune",
description: "13 Seater Tempo Traveller Booking Pune can be planned for short-duration trips, full-day sightseeing, weekend holidays, wedding transportation, corporate events, and multi-day tours. Advance booking helps travelers organize the vehicle according to passenger count, destination, pickup location, and planned itinerary."
},
{
name: "13 Seater AC Tempo Traveller Pune",
description: "13 Seater AC Tempo Traveller Pune is a comfortable option for groups who prefer an air-conditioned vehicle during their journey. It is particularly useful for summer travel, longer routes, family vacations, corporate trips, and sightseeing programs where passengers want a cooler and more pleasant travel environment."
},
{
name: "13 Seater Luxury Tempo Traveller Pune",
description: "13 Seater Luxury Tempo Traveller Pune is designed for groups looking for a more premium travel experience with enhanced comfort during their journey. It can be considered for special family vacations, corporate movements, wedding guests, private tours, and important group travel requirements."
},
{
name: "13 Seater Tempo Traveller for Outstation Pune",
description: "13 Seater Tempo Traveller for Outstation Pune provides a practical solution for groups traveling from Pune to destinations across Maharashtra and neighboring states. The shared vehicle keeps passengers together and makes it easier to coordinate long-distance travel, luggage, sightseeing stops, and return schedules."
},
{
name: "13 Seater Tempo Traveller for Family Trip Pune",
description: "13 Seater Tempo Traveller for Family Trip Pune is ideal for extended families planning vacations, pilgrimages, weekend getaways, and destination tours. Everyone can travel together in one vehicle, making it easier to coordinate family members, luggage, pickup points, and sightseeing plans."
},
{
name: "13 Seater Tempo Traveller for Group Travel Pune",
description: "13 Seater Tempo Traveller for Group Travel Pune is a convenient choice for friends, relatives, colleagues, and organized travel groups. It provides shared transportation for local and outstation journeys while reducing the need for several smaller vehicles traveling on the same route."
},
{
name: "13 Seater Tempo Traveller for Wedding Pune",
description: "13 Seater Tempo Traveller for Wedding Pune is useful for transporting relatives, guests, and family members between homes, hotels, wedding halls, temples, and reception venues. A dedicated group vehicle helps keep wedding transportation organized and allows guests to travel together according to the event schedule."
},
{
name: "13 Seater Tempo Traveller for Corporate Events Pune",
description: "13 Seater Tempo Traveller for Corporate Events Pune supports transportation for conferences, meetings, exhibitions, team outings, seminars, employee gatherings, and business functions. It allows a medium-sized corporate group to move together between offices, hotels, venues, and event locations."
},
{
name: "13 Seater Tempo Traveller for Airport Pickup Pune",
description: "13 Seater Tempo Traveller for Airport Pickup Pune is suitable for families, corporate teams, wedding groups, and travelers arriving at or departing from Pune Airport. Shared airport transportation provides a convenient way to accommodate passengers and luggage together while simplifying pickup and drop-off coordination."
},
{
name: "13 Seater Tempo Traveller Near Me Pune",
description: "13 Seater Tempo Traveller Near Me Pune helps travelers looking for a suitable medium-sized group vehicle for their journey. Ruturaj Enterprises provides rental options for local travel, sightseeing, functions, airport transfers, family trips, and outstation tours based on the group's transportation requirements."
},
{
name: "Affordable 13 Seater Tempo Traveller Pune",
description: "Affordable 13 Seater Tempo Traveller Pune is a practical option for groups that want to share transportation rather than arrange multiple individual cars. Ruturaj Enterprises helps travelers plan cost-conscious group journeys for sightseeing, family vacations, weddings, corporate travel, picnics, and outstation destinations."
},
{
name: "13 Seater Traveller Rental Service Pune",
description: "13 Seater Traveller Rental Service Pune can be arranged for local and long-distance travel requirements, including private tours, events, airport transfers, family trips, and corporate transportation. The rental arrangement can be planned according to the travel duration, destination, passenger requirements, and itinerary."
},
{
name: "13 Seater Tempo Traveller for Picnic Pune",
description: "13 Seater Tempo Traveller for Picnic Pune is a useful choice for families, schools, offices, friends, and community groups organizing recreational outings. The shared vehicle provides convenient transportation while giving passengers the flexibility to carry food, bags, outdoor equipment, and other picnic essentials."
},
{
name: "13 Seater Tempo Traveller for School Trip Pune",
description: "13 Seater Tempo Traveller for School Trip Pune provides organized group transportation for educational visits, recreational excursions, museum trips, nature outings, and other student activities. Schools and organizers can plan suitable pickup and drop-off arrangements for students and accompanying staff."
},
{
name: "13 Seater Tempo Traveller for Local Sightseeing Pune",
description: "13 Seater Tempo Traveller for Local Sightseeing Pune is suitable for families, tourists, friends, and visiting groups who want to explore Pune's historical, cultural, religious, and recreational attractions together. A single vehicle makes it easier to follow a planned sightseeing route without coordinating multiple cars."
},
{
name: "13 Seater Tempo Traveller for Marriage Pune",
description: "13 Seater Tempo Traveller for Marriage Pune can be used to transport family members and guests during marriage ceremonies and related functions. It is convenient for planned movements between hotels, homes, temples, banquet halls, reception venues, and other locations included in the wedding itinerary."
},
{
name: "13 Seater Tempo Traveller for Corporate Travel Pune",
description: "13 Seater Tempo Traveller for Corporate Travel Pune offers shared transportation for employee movements, business meetings, training programs, corporate tours, client visits, and scheduled office activities. It helps medium-sized teams travel together while simplifying transportation coordination."
},
{
name: "13 Seater Tempo Traveller for Outstation Trip Pune",
description: "13 Seater Tempo Traveller for Outstation Trip Pune is well suited for weekend getaways, family holidays, pilgrimage tours, destination visits, and multi-day group journeys from Pune. Travelers can use one dedicated vehicle for the route, making it easier to coordinate travel times, stops, luggage, and return plans."
},
{
name: "13 Seater Luxury Traveller Hire Pune",
description: "13 Seater Luxury Traveller Hire Pune is an option for groups who want premium-oriented transportation for special occasions and important journeys. It can be arranged for corporate travel, wedding transportation, family vacations, private tours, and other situations where a higher level of travel comfort is preferred."
},
{
name: "13 Seater AC Traveller Rental Pune",
description: "13 Seater AC Traveller Rental Pune provides a comfortable shared transportation option for groups traveling around Pune or to outstation destinations. The air-conditioned vehicle is particularly suitable for longer journeys, sightseeing tours, family vacations, corporate travel, wedding groups, and airport transfers."
}
],
tableData: [
["13 Seater Tempo Traveller Pune", "13 Seater Tempo Traveller Hire Pune"],
["13 Seater Tempo Traveller Booking Pune", "13 Seater AC Tempo Traveller Pune"],
["13 Seater Luxury Tempo Traveller Pune", "13 Seater Tempo Traveller for Outstation Pune"],
["13 Seater Tempo Traveller for Family Trip Pune", "13 Seater Tempo Traveller for Group Travel Pune"],
["13 Seater Tempo Traveller for Wedding Pune", "13 Seater Tempo Traveller for Corporate Events Pune"],
["13 Seater Tempo Traveller for Airport Pickup Pune", "13 Seater Tempo Traveller Near Me Pune"],
["Affordable 13 Seater Tempo Traveller Pune", "13 Seater Traveller Rental Service Pune"],
["13 Seater Tempo Traveller for Picnic Pune", "13 Seater Tempo Traveller for School Trip Pune"],
["13 Seater Tempo Traveller for Local Sightseeing Pune", "13 Seater Tempo Traveller for Marriage Pune"],
["13 Seater Tempo Traveller for Corporate Travel Pune", "13 Seater Tempo Traveller for Outstation Trip Pune"],
["13 Seater Luxury Traveller Hire Pune", "13 Seater AC Traveller Rental Pune"]
],
whychoose: [
{
WhyChooseheading: "Ideal Seating for Medium-Sized Groups",
WhyChoosedescription: "A 13 seater Tempo Traveller is a practical choice when a group is larger than a typical car capacity but does not require a large bus. Families, friends, colleagues, tourists, and wedding groups can travel together in one vehicle while keeping their journey organized."
},
{
WhyChooseheading: "Comfort for Long-Distance Journeys",
WhyChoosedescription: "Long routes require a transportation option that allows passengers to remain together throughout the journey. A 13 seater Traveller provides a shared travel environment that is suitable for weekend getaways, family vacations, pilgrimage tours, and multi-day outstation trips."
},
{
WhyChooseheading: "Useful for Weddings and Functions",
WhyChoosedescription: "Wedding transportation often involves moving guests between several locations according to a fixed schedule. A dedicated 13 seater Tempo Traveller can help transport relatives and guests between hotels, homes, ceremony venues, and reception locations with better coordination."
},
{
WhyChooseheading: "Convenient Corporate Group Movement",
WhyChoosedescription: "Corporate teams frequently need transportation for meetings, conferences, exhibitions, training sessions, and employee outings. A 13 seater vehicle provides a convenient shared travel option that can simplify movement between offices, hotels, event venues, and business locations."
},
{
WhyChooseheading: "AC and Premium Travel Options",
WhyChoosedescription: "Different journeys require different levels of comfort, especially when traveling during warm weather or covering longer distances. AC and luxury-oriented 13 seater options can be selected according to the group's preferences and the nature of the trip."
},
{
WhyChooseheading: "Suitable for Local Sightseeing",
WhyChoosedescription: "Exploring multiple attractions in Pune becomes easier when the complete group travels in one vehicle. A 13 seater Tempo Traveller can support planned sightseeing programs for families, tourists, visiting relatives, school groups, and organized private tours."
},
{
WhyChooseheading: "Practical Group Transportation",
WhyChoosedescription: "Arranging several cars for one group can create difficulties with coordination, parking, route planning, and arrival times. A dedicated 13 seater Traveller brings the group together in one transportation arrangement and makes the overall journey easier to manage."
},
{
WhyChooseheading: "Flexible Travel for Different Occasions",
WhyChoosedescription: "The same vehicle category can serve a wide range of travel requirements, from airport pickups and picnics to school trips, family holidays, corporate travel, weddings, local sightseeing, and outstation tours. Ruturaj Enterprises helps travelers plan the transportation according to their specific itinerary and group needs."
}
]
};






const faqData = [
{
question: "Why choose Ruturaj Enterprises for a 13 Seater Tempo Traveller on rent?",
answer: "Ruturaj Enterprises offers 13 Seater Tempo Traveller rental services for groups looking for comfortable and coordinated transportation. This vehicle capacity is suitable for family vacations, corporate outings, weddings, pilgrimages, sightseeing tours, and outstation journeys."
},
{
question: "Who can hire a 13 Seater Tempo Traveller?",
answer: "Families, friends, corporate teams, wedding parties, religious groups, college groups, and organized tour parties can hire a 13 Seater Tempo Traveller when they need to accommodate a medium-sized group in one vehicle."
},
{
question: "Can I use a 13 Seater Tempo Traveller for an outstation trip?",
answer: "A 13 Seater Tempo Traveller can be arranged for outstation journeys from Pune to destinations such as Goa, Mumbai, Nashik, Shirdi, Mahabaleshwar, Kolhapur, and other locations according to the group's travel itinerary."
},
{
question: "Is the 13 Seater Tempo Traveller suitable for family tours?",
answer: "Families can benefit from the shared seating arrangement of a 13 Seater Tempo Traveller during holidays and group tours. Keeping everyone in one vehicle makes travel coordination simpler and provides practical space for passengers and their belongings."
},
{
question: "Can companies rent a 13 Seater Tempo Traveller for corporate travel?",
answer: "Corporate groups can use a 13 Seater Tempo Traveller for employee outings, conferences, business visits, team-building programs, training events, and company tours where a medium-sized group needs to travel together."
},
{
question: "Can I book a 13 Seater Tempo Traveller for a wedding?",
answer: "Wedding groups can arrange a 13 Seater Tempo Traveller for transporting relatives and guests between homes, hotels, wedding venues, reception locations, railway stations, or airports as part of the event transportation plan."
},
{
question: "Is a 13 Seater Tempo Traveller suitable for pilgrimage tours?",
answer: "Religious groups can hire this vehicle for pilgrimage journeys to temples and spiritual destinations. Traveling together allows the group to follow a common itinerary while avoiding the need to coordinate multiple smaller vehicles."
},
{
question: "Can I hire a 13 Seater Tempo Traveller for sightseeing?",
answer: "Sightseeing groups can use a 13 Seater Tempo Traveller for local and outstation tours, allowing passengers to travel together between multiple attractions. The itinerary can be planned according to the group's preferred destinations and available time."
},
{
question: "Can luggage be carried in a 13 Seater Tempo Traveller?",
answer: "The vehicle provides practical space for passengers and their travel belongings, although the available luggage capacity depends on the quantity of bags and the seating arrangement. Ruturaj Enterprises can help select an appropriate option based on your requirements."
},
{
question: "How can I book a 13 Seater Tempo Traveller on rent?",
answer: "To reserve a 13 Seater Tempo Traveller with Ruturaj Enterprises, provide your pickup location, travel date, destination, passenger count, trip duration, and journey requirements. The rental arrangement can then be planned around your group's itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Amol Kapse",
feedback:
"We booked a 13 Seater Tempo Traveller from Ruturaj Enterprises for our family tour. The seating arrangement was comfortable for our group, and everyone could travel together with their bags. The overall experience was convenient and made our trip easier to manage.",
rating: 5
},
{
id: 2,
name: "Miss. Isha Kulkarni",
feedback:
"Ruturaj Enterprises provided a 13 Seater Tempo Traveller for our friends' outing, and it was a great option for our group size. We appreciated having one vehicle for the complete journey, which made coordination between different stops simple and stress-free.",
rating: 5
}
];














    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "13 Seater Tempo Traveller on Rent",
  "image": "https://ruturajenterprises.com/assets/images/13-seater-tempo-traveller-on-rent.webp",
  "description":
    "13 Seater Tempo Traveller on Rent is a convenient group travel option from Ruturaj Enterprises for families, friends, corporate teams, wedding groups, tourists, school and college groups, and other passengers traveling together from Pune. 13 Seater Tempo Traveller Pune is suitable for local sightseeing, airport transfers, family tours, corporate travel, wedding transportation, weekend trips, pilgrimage journeys and long-distance outstation travel. 13 Seater Tempo Traveller Hire Pune allows groups to travel together in one spacious vehicle instead of arranging multiple cars, making it suitable for organized tours and customized travel plans. 13 Seater Tempo Traveller Booking Pune can be arranged according to the pickup location, journey schedule, travel duration, destination and passenger requirements. 13 Seater AC Tempo Traveller Pune provides a comfortable travel environment for warm-weather journeys, longer routes and multi-day tours, while 13 Seater Luxury Tempo Traveller Pune is suitable for passengers looking for a more premium and comfortable group transportation experience. 13 Seater Tempo Traveller for Outstation Pune can be used for journeys to Mumbai, Lonavala, Mahabaleshwar, Panchgani, Nashik, Shirdi, Kolhapur, Satara, Goa, Konkan, Alibaug, Matheran, Ratnagiri, Ganpatipule and other popular destinations across Maharashtra and nearby states. 13 Seater Tempo Traveller for Family Trip Pune is useful for family vacations, reunions, weekend getaways and customized holiday tours, while 13 Seater Tempo Traveller for Group Travel Pune provides practical transportation for friends, tourist groups, corporate teams, school groups, college students and event participants. The vehicle can also be arranged for Pune Darshan, temple tours, pilgrimage trips, destination weddings, marriage functions, reception transportation, airport pickup and drop, railway station transfers, hotel transfers, corporate events, employee outings, conferences, exhibitions and industrial visits. Pickup and drop facilities can be planned from areas including Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Pimpri, Chinchwad, Talegaon, Moshi, Bhosari and surrounding Pune locations. Ruturaj Enterprises supports flexible local and outstation rental requirements with experienced drivers, making the 13 Seater Tempo Traveller suitable for single-day travel, weekend journeys, multi-day tours, group sightseeing, corporate transportation, wedding guest movement and customized road trips from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/13-seater-tempo-traveller-on-rent"
  }
};






    return (
        <div>


<Helmet>
  <title>13 Seater Tempo Traveller on Rent | 13 Seater Tempo Traveller Pune | +91 9763381382</title>

  <meta
    name="description"
    content="13 Seater Tempo Traveller on Rent in Pune for family trips, group tours, outstation journeys, corporate events, weddings, sightseeing, airport transfers and multi-day travel with driver."
  />

  <meta
    name="keywords"
    content="13 Seater Tempo Traveller Pune, 13 Seater Tempo Traveller Hire Pune, 13 Seater Tempo Traveller Booking Pune, 13 Seater AC Tempo Traveller Pune, 13 Seater Luxury Tempo Traveller Pune, 13 Seater Tempo Traveller for Outstation Pune, 13 Seater Tempo Traveller for Family Trip Pune, 13 Seater Tempo Traveller for Group Travel Pune, 13 Seater Tempo Traveller on Rent, 13 Seater Tempo Traveller Rental Pune, 13 Seater Tempo Traveller Hire in Pune, 13 Seater Tempo Traveller Booking Pune, 13 Seater Tempo Traveller with Driver Pune, 13 Seater AC Tempo Traveller on Rent Pune, 13 Seater AC Tempo Traveller Hire Pune, 13 Seater AC Tempo Traveller Rental Pune, 13 Seater Luxury Tempo Traveller on Rent Pune, 13 Seater Luxury Tempo Traveller Hire Pune, 13 Seater Luxury Tempo Traveller Rental Pune, Premium 13 Seater Tempo Traveller Pune, Affordable 13 Seater Tempo Traveller Pune, 13 Seater Tempo Traveller for Group Tour Pune, 13 Seater Tempo Traveller for Friends Trip Pune, 13 Seater Tempo Traveller for Family Tour Pune, 13 Seater Tempo Traveller for Family Vacation Pune, 13 Seater Tempo Traveller for Weekend Trip Pune, 13 Seater Tempo Traveller for Holiday Trip Pune, 13 Seater Tempo Traveller for Road Trip Pune, 13 Seater Tempo Traveller for Sightseeing Pune, 13 Seater Tempo Traveller for Local Sightseeing Pune, 13 Seater Tempo Traveller for Pune Darshan, 13 Seater Tempo Traveller for Maharashtra Tour Pune, 13 Seater Tempo Traveller for Goa Trip Pune, 13 Seater Tempo Traveller for Mumbai Trip Pune, 13 Seater Tempo Traveller for Lonavala Trip Pune, 13 Seater Tempo Traveller for Mahabaleshwar Trip Pune, 13 Seater Tempo Traveller for Panchgani Trip Pune, 13 Seater Tempo Traveller for Nashik Trip Pune, 13 Seater Tempo Traveller for Shirdi Trip Pune, 13 Seater Tempo Traveller for Kolhapur Trip Pune, 13 Seater Tempo Traveller for Satara Trip Pune, 13 Seater Tempo Traveller for Konkan Trip Pune, 13 Seater Tempo Traveller for Alibaug Trip Pune, 13 Seater Tempo Traveller for Matheran Trip Pune, 13 Seater Tempo Traveller for Ratnagiri Trip Pune, 13 Seater Tempo Traveller for Ganpatipule Trip Pune, 13 Seater Tempo Traveller for Dapoli Trip Pune, 13 Seater Tempo Traveller for Outstation Trip Pune, 13 Seater Tempo Traveller Outstation Rental Pune, 13 Seater Tempo Traveller One Way Pune, 13 Seater Tempo Traveller Round Trip Pune, 13 Seater Tempo Traveller Full Day Rental Pune, 13 Seater Tempo Traveller Multi Day Rental Pune, 13 Seater Tempo Traveller Weekend Rental Pune, 13 Seater Tempo Traveller Tour Package Pune, 13 Seater Tempo Traveller Sightseeing Package Pune, 13 Seater Tempo Traveller Family Tour Package Pune, 13 Seater Tempo Traveller Group Tour Package Pune, 13 Seater Tempo Traveller Corporate Tour Pune, 13 Seater Tempo Traveller Corporate Travel Pune, 13 Seater Tempo Traveller for Corporate Events Pune, 13 Seater Tempo Traveller for Corporate Outing Pune, 13 Seater Tempo Traveller for Employee Transportation Pune, 13 Seater Tempo Traveller for Office Trip Pune, 13 Seater Tempo Traveller for Company Event Pune, 13 Seater Tempo Traveller for Business Travel Pune, 13 Seater Tempo Traveller for Conference Pune, 13 Seater Tempo Traveller for Seminar Pune, 13 Seater Tempo Traveller for Exhibition Pune, 13 Seater Tempo Traveller for Training Pune, 13 Seater Tempo Traveller for Industrial Visit Pune, 13 Seater Tempo Traveller for Wedding Pune, 13 Seater Tempo Traveller for Wedding Guest Pune, 13 Seater Tempo Traveller for Marriage Pune, 13 Seater Tempo Traveller for Reception Pune, 13 Seater Tempo Traveller for Destination Wedding Pune, 13 Seater Tempo Traveller for Wedding Guest Transportation Pune, 13 Seater Tempo Traveller for Event Transportation Pune, 13 Seater Tempo Traveller for Airport Transfer Pune, 13 Seater Tempo Traveller for Airport Pickup Pune, 13 Seater Tempo Traveller for Airport Drop Pune, 13 Seater Tempo Traveller for Pune Airport, 13 Seater Tempo Traveller for Railway Station Transfer Pune, 13 Seater Tempo Traveller for Pune Railway Station, 13 Seater Tempo Traveller for Hotel Transfer Pune, 13 Seater Tempo Traveller for Resort Transfer Pune, 13 Seater Tempo Traveller for Guest Pickup Pune, 13 Seater Tempo Traveller for Guest Drop Pune, 13 Seater Tempo Traveller for School Trip Pune, 13 Seater Tempo Traveller for College Trip Pune, 13 Seater Tempo Traveller for Student Group Pune, 13 Seater Tempo Traveller for Picnic Pune, 13 Seater Tempo Traveller for Temple Tour Pune, 13 Seater Tempo Traveller for Pilgrimage Pune, 13 Seater Tempo Traveller for Religious Tour Pune, 13 Seater Tempo Traveller for Tourist Group Pune, 13 Seater Tempo Traveller for Group Transportation Pune, 13 Seater Tempo Traveller for Family Transportation Pune, 13 Seater Tempo Traveller for Corporate Transportation Pune, 13 Seater Tempo Traveller for Event Transportation Pune, 13 Seater Tempo Traveller Rental Near Pune, 13 Seater Tempo Traveller Hire Near Pune, 13 Seater Tempo Traveller Booking Near Pune, 13 Seater Tempo Traveller Rental Pimpri Chinchwad, 13 Seater Tempo Traveller Hire Pimpri Chinchwad, 13 Seater Tempo Traveller Rental Wakad, 13 Seater Tempo Traveller Rental Hinjewadi, 13 Seater Tempo Traveller Rental Kothrud, 13 Seater Tempo Traveller Rental Baner, 13 Seater Tempo Traveller Rental Aundh, 13 Seater Tempo Traveller Rental Viman Nagar, 13 Seater Tempo Traveller Rental Kharadi, 13 Seater Tempo Traveller Rental Hadapsar, 13 Seater Tempo Traveller Rental Kondhwa, 13 Seater Tempo Traveller Rental Katraj, 13 Seater Tempo Traveller Rental Shivajinagar, 13 Seater Tempo Traveller Rental Swargate, 13 Seater Tempo Traveller Rental Pimpri, 13 Seater Tempo Traveller Rental Chinchwad, 13 Seater Tempo Traveller Rental Talegaon, 13 Seater Tempo Traveller Rental Moshi, 13 Seater Tempo Traveller Rental Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onethreetempo ;